var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2134 2134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2133.33,
    height: 2133.33,
    style: {
      fill: "#f7df1e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.06,1666.67c42.972,70.163 98.879,121.736 197.757,121.736c83.064,-0 136.127,-41.516 136.127,-98.879c-0,-68.74 -54.519,-93.088 -145.947,-133.079l-50.117,-21.503c-144.66,-61.629 -240.762,-138.836 -240.762,-302.053c0,-150.349 114.557,-264.804 293.588,-264.804c127.458,0 219.09,44.36 285.121,160.508l-156.105,100.233c-34.371,-61.63 -71.45,-85.909 -129.016,-85.909c-58.718,-0 -95.933,37.249 -95.933,85.909c0,60.14 37.249,84.487 123.26,121.735l50.116,21.469c170.328,73.041 266.497,147.505 266.497,314.921c0,180.487 -141.782,279.365 -332.19,279.365c-186.176,-0 -306.455,-88.72 -365.308,-205.003l162.912,-94.646Zm-708.165,17.372c31.492,55.873 60.14,103.111 129.016,103.111c65.862,-0 107.412,-25.77 107.412,-125.969l-0,-681.65l200.465,-0l0,684.359c0,207.577 -121.701,302.053 -299.344,302.053c-160.508,0 -253.46,-83.064 -300.732,-183.111l163.183,-98.793Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.72222f60d61656bf7d14e6c0f7bf5514.svg";
export { ForwardRef as ReactComponent };